import ModalBindings from '../modal/ModalBindings';
import CatalogSearchFilter from '../catalog-search-filter/catalog-search-filter';
import PreloaderOverlay from '../preloader-overlay/preloader-overlay';
import mainConfig from '../../../mainConfig';
import _ from '../../../../node_modules/lodash/lodash';

export default new class CatalogTable {
    constructor() {
        this.productOfferCheckboxes = '.js-productOfferCheckbox';
        this.checkAllCheckbox = '.js-checkAll';
        this.catalogInput = '.js-catalogTableInput';
        this.productOffer = '.js-productOffer';
        this.catalogModalConfirmBtn = '.js-catalogModalConfirm';
        this.catalogModalCancelBtn = '.js-catalogModalCancel';
        this.publishBtn = '.js-makePublished';
        this.unpublishBtn = '.js-makeUnpublished';
    }

    init() {
        this.bindEvents();
    }

    /**
     * bind event listeners
     */
    bindEvents() {
        $(document)
            /**
             * handles the click on checkbox in the header of the offer table
             */
            .on('click', this.checkAllCheckbox, () => {
                this.toggleProductOffersChecked();
                CatalogSearchFilter.toggleGroupActions();
                CatalogSearchFilter.setCheckedOffersLength();
            })
            /**
             *  saves old values of price and amount if user set this inputs empty or "0" value
             */
            .on('focus', this.catalogInput, (e) => {
                this.saveOldInputValue($(e.target));
            })
            /**
             * validate values of price and amount on blur
             */
            .on('blur', this.catalogInput, (e) => {
                let $currentOffer = $(e.target).closest(this.productOffer);

                this.isStatusChanges = false;

                if (e.target.value.length === 0) {
                    this.setDefaultValue($(e.target));
                }

                if (this.validateCatalogInput($(e.target))) {
                    let data = this.getOfferData($currentOffer);

                    this.offerDataChangeRequest(data);
                } else {
                    this.showUnpublishModal($(e.target));
                }
            })
            /**
             * handles the click on "cancel" button in popup
             */
            .on('click', this.catalogModalCancelBtn, (e) => {
                this.isStatusChanges = false;
                this.setOldValueInInput();
            })
            /**
             * handles the click on "confirm" button in popup
             */
            .on('click', this.catalogModalConfirmBtn, (e) => {
                e.preventDefault();
                this.isStatusChanges = true;
                let data = this.getOfferData(),
                    params = {dontSetOldValue: true};

                this.offerStatusChangeRequest(data, params);
            })
            /**
             * handles the click on "publish" button in the offer table
             */
            .on('click', this.publishBtn, (e) => {
                e.preventDefault();
                this.isStatusChanges = true;
                let $currentProductOffer = $(e.target).closest(this.productOffer);

                if (!this.doesProductOfferHasError($currentProductOffer)) {
                    let data = this.getOfferData($currentProductOffer);

                    this.offerStatusChangeRequest(data);
                }
            })
            /**
             * handles the click on "unpublish" button in the offer table
             */
            .on('click', this.unpublishBtn, (e) => {
                e.preventDefault();
                this.isStatusChanges = true;
                let data = this.getOfferData($(e.target).closest(this.productOffer));

                this.offerStatusChangeRequest(data);
            });
    }

    setDefaultValue ($input) {
        $input.val(0);
    }

    doesProductOfferHasError($productOffer) {
        let inputs = $productOffer.find(this.catalogInput),
            doesOfferContainsError = false;

        for (let i = 0; i < inputs.length; i++) {
            let $input = $(inputs[i]);

            if ($input.val() == 0 || $input.val().length == 0) {
                $input.addClass(mainConfig.errorMessages.inputErrorClassName);
                doesOfferContainsError = true;
            } else {
                $input.removeClass(mainConfig.errorMessages.inputErrorClassName);
            }
        }

        if (doesOfferContainsError) {
            $productOffer.addClass(mainConfig.errorMessages.inputErrorClassName);
        } else {
            $productOffer.removeClass(mainConfig.errorMessages.inputErrorClassName);
        }

        return doesOfferContainsError;
    }

    saveOldInputValue($input) {
        if ($input.attr('name') == 'amount') {
            this.offerOldAmount = $input.val();
            this.$offerAmountInput = $input;
        } else if ($input.attr('name') == 'price') {
            this.offerOldPrice = $input.val();
            this.$offerPriceInput = $input;
        }
    }

    toggleProductOffersChecked() {
        let $productOfferCheckboxes = $(this.productOfferCheckboxes),
            isChecked = $(this.checkAllCheckbox).prop('checked');

        for (let i = 0; i < $productOfferCheckboxes.length; i++) {
            $($productOfferCheckboxes[i]).prop('checked', isChecked);
        }
    }

    validateCatalogInput($input) {
        this.$currentProductOffer = $input.closest(this.productOffer);

        if ((this.$currentProductOffer.attr('data-is-published') === 'true') && $input.val() == 0) {
            return false;
        }

        this.$currentProductOffer.removeClass(mainConfig.errorMessages.inputErrorClassName);
        $input.removeClass(mainConfig.errorMessages.inputErrorClassName);

        return true;
    }

    showUnpublishModal($input) {
        let $unpublishModal = $('.modal[data-modal="unpublish-offer-modal"]');
        this.isModalOpened = true;

        this.$currentInput = $input;
        ModalBindings.openModal($unpublishModal);
    }

    setOldValueInInput() {
        if (this.$currentInput.attr('name') == 'amount') {
            this.$offerAmountInput.val(this.offerOldAmount);
        } else if (this.$currentInput.attr('name') == 'price') {
            this.$offerPriceInput.val(this.offerOldPrice);
        }
        ModalBindings.hideModal();
    }

    getOfferData($productOffer = null) {
        if ($productOffer) {
            this.$currentProductOffer = $productOffer;
        }

        let data = this.$currentProductOffer.serializeArray(),
            currentProductOfferId = this.$currentProductOffer.attr('data-product-offer-id'),
            currentProductOfferStatus = this.$currentProductOffer.attr('data-is-published');

        data.push({name: 'offerId', value: currentProductOfferId});


        if (this.isStatusChanges) {
            data.push({name: 'isPublish', value: currentProductOfferStatus == 'true' ? 'false' : 'true'});
        } else {
            data.push({name: 'isPublish', value: currentProductOfferStatus == 'true' ? 'true' : 'false'});
        }

        let dataForRequest = CatalogSearchFilter.reformatData(data);

        return dataForRequest;
    }


    setProductOfferStatus(response) {
        if (response) {
            let $productOffers = $(this.productOffer),
                currentProductOffer = $(_.find($productOffers, (item) => {
                        return $(item).attr('data-product-offer-id') == response.id;
                    })
                );

            currentProductOffer.attr('data-is-published', response.isPublished);
            if (response.isPublished) {
                currentProductOffer.addClass('_published');
                currentProductOffer.removeClass('_unpublished');
            } else if (!response.isPublished) {
                currentProductOffer.removeClass('_published');
                currentProductOffer.addClass('_unpublished');
            }
        }
    }

    offerStatusChangeRequest(data, params) {

        $.request('OffersList::onUpdateOffer', {
            data: data,
            loading: '.js-preloaderOverlay',
            complete: (response) => {

                let obResult = response.responseJSON;
                if(!obResult || !obResult.result) {
                    return;
                }
                
                let obOfferData = obResult.data,
                    responseAction = {
                    id: obOfferData.id,
                    isPublished: obOfferData.status
                };
                this.setProductOfferStatus(responseAction);
                if (this.isModalOpened) {
                    ModalBindings.hideModal(params);
                }
            }
        });
    }

    offerDataChangeRequest(data) {

        $.request('OffersList::onUpdateOffer', {
            data: data,
            loading: '.js-preloaderOverlay',
        });
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/catalog-table/catalog-table.js